import { basePath } from '../next.config'
import loggingService from './loggingService'

class ApiError extends Error {
	readonly statusCode: number
	constructor(response: Response) {
		super(`HTTP error: status: ${response.status} - ${response.statusText}`)
		this.statusCode = response.status
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const getCurrentProjects = async (
	page: number,
	take: number,
	sort: number,
	filter: number
): Promise<Project[]> => {
	let response: Response

	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/current?page=${page}&take=${take}&sort=${sort}&filter=${filter}`
		)

		if (!response.ok) {
			throw new ApiError(response)
		}

		return await response.json()
	} catch (error) {
		loggingService('Error retrieving projects', error, {
			errorType: 'Projects',
			fetchUrl:
				response?.url ??
				`${basePath}/api/musicapp/projects/current?page=${page}&take=${take}&sort=${sort}&filter=${filter}`,
			fetchStatus: response?.status ?? 'Network Failed',
		})
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const deleteProjectById = async (id: string): Promise<boolean> => {
	let response: Response

	try {
		response = await fetch(`${basePath}/api/musicapp/projects/${id}`, {
			method: 'DELETE',
		})
		if (!response.ok) {
			throw new ApiError(response)
		}
		return response.status == 204
	} catch (error) {
		loggingService('Error deleting a project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url ?? `${basePath}/api/musicapp/projects/${id}`,
			fetchStatus: response?.status ?? 'Network Failed',
		})
		return false
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const getProject = async (id: string): Promise<Project> => {
	let response: Response

	try {
		response = await fetch(`${basePath}/api/musicapp/projects/${id}`, {
			method: 'GET',
		})

		if (!response.ok) {
			throw new ApiError(response)
		}

		return await response.json()
	} catch (error) {
		loggingService('Error retrieving a project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url ?? `${basePath}/api/musicapp/projects/${id}`,
			fetchStatus: response?.status ?? 'Network Failed',
		})
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const getCollaborators = async (
	projectId: string
): Promise<ProjectCollaborator[]> => {
	let response: Response
	try {
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/collaborators`,
			{
				method: 'GET',
			}
		)

		if (!response.ok) {
			throw new ApiError(response)
		}

		return await response.json()
	} catch (error) {
		loggingService('Error getting collaborators', error, {
			errorType: 'Project API',
			fetchUrl:
				response?.url ??
				`${basePath}/api/musicapp/projects/${projectId}/collaborators`,
			fetchStatus: response?.status ?? 'Network Failed',
		})
		return []
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const addProject = async (
	name: string,
	description?: string
): Promise<Project> => {
	let response

	try {
		response = await fetch(`${basePath}/api/musicapp/projects`, {
			body: JSON.stringify({ name, description }),
			method: 'POST',
		})

		if (!response.ok) {
			throw new ApiError(response)
		}

		return await response.json()
	} catch (error) {
		loggingService('Error adding a project', error, {
			errorType: 'Project API',
			fetchUrl: response?.url ?? `${basePath}/api/musicapp/projects`,
			fetchStatus: response?.status ?? 'Network Failed',
		})
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const sendProject = async (
	projectId: string,
	targetUserEmail: string,
	isOpenToAllOrganisation: boolean
): Promise<ProjectResponse> => {
	let response: Response
	try {
		//add Project to userID
		response = await fetch(
			`${basePath}/api/musicapp/projects/${projectId}/send`,
			{
				body: JSON.stringify({ targetUserEmail, isOpenToAllOrganisation }),
				method: 'POST',
			}
		)

		if (!response.ok) {
			throw new ApiError(response)
		}

		const result = await response.json()
		return {
			...result,
			statusCode: response.status || 200,
		}
	} catch (error) {
		loggingService('Error copying project to account', error, {
			errorType: 'Project API',
			fetchUrl:
				response?.url ?? `${basePath}/api/musicapp/projects/${projectId}/send`,
			fetchStatus: response?.status ?? 'Network Failed',
		})
		return error
	}
}
